import { MicrositeContext } from 'context';
import { useQual } from 'hooks/useQual';
import { useStore } from 'hooks/useStore';
import { LandingPageContent } from './LandingPageContent';
import { PageRoutes } from 'constants/pageRoutes';
import router from 'next/router';
import { useContext, useEffect, useState } from 'react';

export function Landing() {
  const { enableMicrositeLanding } = useContext(MicrositeContext);

  const visitingQual = useStore((store) => store.visitingQual);
  const setVisitingQual = useStore((store) => store.setVisitingQual);
  const setAcceptedUpdaterTerms = useStore(
    (store) => store.setAcceptedUpdaterTerms
  );
  const [visitChecked, setVisitChecked] = useState(false);
  const qual = useQual();

  useEffect(() => {
    if (!enableMicrositeLanding) {
      router.replace(PageRoutes.quiz);
      return;
    }
  }, [enableMicrositeLanding]);

  useEffect(() => {
    const qualEncoded = btoa(
      unescape(encodeURIComponent(JSON.stringify(qual)))
    );
    if (!qualEncoded.length || qualEncoded !== visitingQual) {
      setAcceptedUpdaterTerms(false);
      setVisitChecked(true);
      setVisitingQual(qualEncoded);
    } else {
      setVisitChecked(true);
    }
  }, []);

  if (!visitChecked) return <></>;
  if (enableMicrositeLanding) return <LandingPageContent />;
}
